import Request from '../request';
import { IPublicKeyResourceShort } from '../../props/data/key';

const KeyService = {
  retrieve: async (qs?: string): Promise<IPublicKeyResourceShort[]> => {
    try {
      const results = await Request.get(`/api/keys?${qs || ''}`);
      return results;
    } catch (e) {
      throw e;
    }
  },
  get: async (id: string): Promise<IPublicKeyResourceShort> => {
    try {
      const results = await Request.get(`/api/keys/${id}`);
      return results;
    } catch (e) {
      throw e;
    }
  },
  new: async (data: FormData): Promise<IPublicKeyResourceShort> => {
    try {
      const result = await Request.post(`/api/keys`, data, 'multipart/form-data');
      return result;
    } catch (e) {
      throw e;
    }
  },
  update: async (id: string, data: FormData): Promise<IPublicKeyResourceShort> => {
    try {
      const result = await Request.post(`/api/keys/${id}?_method=PUT`, data, 'multipart/form-data');
      return result;
    } catch (e) {
      throw e;
    }
  },
  delete: async (id: string): Promise<void> => {
    try {
      await Request.delete(`/api/keys/${id}`);
      return;
    } catch (e) {
      throw e;
    }
  },
};

export default KeyService;
